import React from 'react';
import { Helmet } from 'react-helmet';
export function SEO() {
  const siteTitle = 'Notary Public Fresno | Mobile Notary Services in Fresno, CA';
  const siteDescription = 'Find trusted notary public services in Fresno, CA. Compare top-rated mobile notary services, 24/7 availability, real estate closings, legal documents, and more. Licensed and bonded notaries serving Fresno County.';
  const siteUrl = 'https://notarypublicfresno.com';
  const keywords = 'notary public fresno, mobile notary fresno, notary services fresno ca, fresno notary, notary near me fresno, 24 hour notary fresno, real estate notary fresno, loan signing agent fresno';
  // Schema.org structured data for the website
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Notary Public Fresno',
    url: siteUrl,
    description: siteDescription,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/#contact?q={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };
  // Local Business Schema for Fresno area notary services
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Notary Public Fresno',
    description: 'Directory of trusted notary public services in Fresno, California. Find licensed, bonded, and insured mobile notaries available 24/7.',
    areaServed: {
      '@type': 'City',
      name: 'Fresno',
      '@id': 'https://en.wikipedia.org/wiki/Fresno,_California'
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Fresno',
      addressRegion: 'CA',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '36.7378',
      longitude: '-119.7871'
    },
    serviceType: ['Mobile Notary Service', 'Real Estate Notarization', 'Legal Document Notarization', 'Loan Signing Services', 'Apostille Services']
  };
  // Individual notary listings schema
  const notaryListings = [{
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: "Marie's Mobile Notary",
    image: 'https://via.placeholder.com/400x300?text=Marie%27s+Mobile+Notary',
    '@id': 'maries-mobile-notary-fresno',
    url: 'https://www.google.com/maps/search/?api=1&query=4472+N+10th+St+Fresno+CA+93726',
    telephone: '(559) 903-5902',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '4472 N 10th St',
      addressLocality: 'Fresno',
      addressRegion: 'CA',
      postalCode: '93726',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '36.7378',
      longitude: '-119.7871'
    },
    openingHoursSpecification: [{
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '14:00',
      closes: '20:00'
    }, {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '14:00',
      closes: '19:00'
    }],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5.0',
      reviewCount: '78'
    },
    priceRange: '$$'
  }, {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: "Hector Picon's Mobile Notary Service",
    '@id': 'hector-picon-mobile-notary-clovis',
    url: 'https://www.google.com/maps/search/?api=1&query=635+Barstow+Ave+16+Clovis+CA+93612',
    telephone: '(559) 800-8000',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '635 Barstow Ave #16',
      addressLocality: 'Clovis',
      addressRegion: 'CA',
      postalCode: '93612',
      addressCountry: 'US'
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '88'
    }
  }, {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: "GG's Notary",
    '@id': 'ggs-notary-fresno',
    url: 'https://www.google.com/maps/search/?api=1&query=5555+N+Dante+Ave+Fresno+CA+93722',
    telephone: '(559) 819-0038',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '5555 N Dante Ave',
      addressLocality: 'Fresno',
      addressRegion: 'CA',
      postalCode: '93722',
      addressCountry: 'US'
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '06:00',
      closes: '21:30'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5.0',
      reviewCount: '16'
    }
  }];
  return <Helmet data-id="element-204">
      {/* Primary Meta Tags */}
      <title data-id="element-205">{siteTitle}</title>
      <meta name="title" content={siteTitle} data-id="element-206" />
      <meta name="description" content={siteDescription} data-id="element-207" />
      <meta name="keywords" content={keywords} data-id="element-208" />
      <link rel="canonical" href={siteUrl} data-id="element-209" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-210" />
      <meta property="og:url" content={siteUrl} data-id="element-211" />
      <meta property="og:title" content={siteTitle} data-id="element-212" />
      <meta property="og:description" content={siteDescription} data-id="element-213" />
      <meta property="og:site_name" content="Notary Public Fresno" data-id="element-214" />
      <meta property="og:locale" content="en_US" data-id="element-215" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-216" />
      <meta property="twitter:url" content={siteUrl} data-id="element-217" />
      <meta property="twitter:title" content={siteTitle} data-id="element-218" />
      <meta property="twitter:description" content={siteDescription} data-id="element-219" />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" data-id="element-220" />
      <meta name="language" content="English" data-id="element-221" />
      <meta name="revisit-after" content="7 days" data-id="element-222" />
      <meta name="author" content="Notary Public Fresno" data-id="element-223" />
      <meta name="geo.region" content="US-CA" data-id="element-224" />
      <meta name="geo.placename" content="Fresno" data-id="element-225" />
      <meta name="geo.position" content="36.7378;-119.7871" data-id="element-226" />
      <meta name="ICBM" content="36.7378, -119.7871" data-id="element-227" />

      {/* Schema.org JSON-LD - Organization */}
      <script type="application/ld+json" data-id="element-228">
        {JSON.stringify(organizationSchema)}
      </script>

      {/* Schema.org JSON-LD - Local Business */}
      <script type="application/ld+json" data-id="element-229">
        {JSON.stringify(localBusinessSchema)}
      </script>

      {/* Schema.org JSON-LD - Individual Notary Listings */}
      {notaryListings.map((listing, index) => <script key={index} type="application/ld+json" data-id="element-230">
          {JSON.stringify(listing)}
        </script>)}
    </Helmet>;
}